import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const SendLiner24 = (props)=>{
    var _props_size;
    const defaultSize = 24;
    const size = (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : defaultSize;
    const strokeWidth = 1.5 * defaultSize / size;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10.1099 13.65L13.6899 10.06M7.39993 6.32L15.8899 3.49C19.6999 2.22 21.7699 4.3 20.5099 8.11L17.6799 16.6C15.7799 22.31 12.6599 22.31 10.7599 16.6L9.91993 14.08L7.39993 13.24C1.68993 11.34 1.68993 8.23 7.39993 6.32Z",
            stroke: "currentColor",
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
